<template>
	<div class="c-page-nav__item">
		<a :href="url" class="c-button">
			<slot />
		</a>
	</div>
</template>

<script>
export default {
	name: "VPageNavAction",
	props: {
		url: {
			type: String,
			required: true
		}
	}
};
</script>
